var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.36267 0C3.59482 0 3.783 0.18819 3.783 0.420333V0.840667H5.88467V0.420333C5.88467 0.18819 6.07285 0 6.305 0C6.53715 0 6.72533 0.18819 6.72533 0.420333V0.840667H8.827V0.420333C8.827 0.18819 9.01518 0 9.24733 0C9.47948 0 9.66767 0.18819 9.66767 0.420333V0.840667C11.2927 0.840667 12.61 2.15799 12.61 3.783V9.66767C12.61 11.2927 11.2927 12.61 9.66767 12.61H2.94233C1.31733 12.61 0 11.2927 0 9.66767V3.783C0 2.15799 1.31733 0.840667 2.94233 0.840667V0.420333C2.94233 0.18819 3.13052 0 3.36267 0ZM8.61683 10.5083C8.84898 10.5083 9.03717 10.3202 9.03717 10.088C9.03717 9.85585 8.84898 9.66767 8.61683 9.66767H3.99317C3.76102 9.66767 3.57283 9.85585 3.57283 10.088C3.57283 10.3202 3.76102 10.5083 3.99317 10.5083H8.61683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.f0218a4bc1e00058daf59f7fd4b40f21.svg";
export { ForwardRef as ReactComponent };